export default __webpack_public_path__ + "static/media/Bristol.edef645e.jpg";